import { axiosInstance } from './base'

////////////

function getApiBasePath(orgId: string, clusterId: string): string {
  return `/clinic/api/v1/dashboard/proxy/orgs/${orgId}/clusters/${clusterId}/pd/dashboard/api`
}

export const getAllConfigurations = (orgId: string, clusterId: string) => {
  return axiosInstance.get(
    `${getApiBasePath(orgId, clusterId)}/configuration/all`,
    {
      headers: {
        'x-cluster-id': clusterId,
        'x-org-id': orgId
      }
    }
  )
}
